import { connect } from 'react-redux';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { ResourceState } from '@mews-commander/data-access';
import { getResourceState, getResourceStateReason } from '@mews-commander/legacy-entities/src/ducks/resources';
import { ApplicationState } from '@mews-commander/types';
import { TooltippedTag } from '@mews-commander/ui';
import { getTagVariantFromResourceState } from '@mews-commander/utils';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface StateProps {
    state: ResourceState | undefined;
    reason: string | undefined;
}

interface OwnProps {
    resourceId: string | undefined;
    withTooltip?: boolean;
    short?: boolean;
}

export const RESOURCE_STATE_TEXT_KEY_MAP: Record<ResourceState, Mews.TextKey> = {
    [ResourceState.Dirty]: TextKey.Dirty,
    [ResourceState.Clean]: TextKey.Clean,
    [ResourceState.Inspected]: TextKey.Inspected,
    [ResourceState.OutOfService]: TextKey.OutOfService,
    [ResourceState.OutOfOrder]: TextKey.OutOfOrder,
};

export const RESOURCE_STATE_SHORT_TEXT_KEY_MAP: Record<ResourceState, Mews.TextKey> = {
    [ResourceState.Dirty]: TextKey.RoomStateShortDirty,
    [ResourceState.Clean]: TextKey.RoomStateShortClean,
    [ResourceState.Inspected]: TextKey.RoomStateShortInspected,
    [ResourceState.OutOfService]: TextKey.RoomStateShortOutOfService,
    [ResourceState.OutOfOrder]: TextKey.RoomStateShortOutOfOrder,
};

const ResourceStateTag = ({ state, reason, withTooltip = true, short = false }: OwnProps & StateProps) => {
    if (!state) {
        return null;
    }

    const tagVariant = getTagVariantFromResourceState(state);
    const textKey = short ? RESOURCE_STATE_SHORT_TEXT_KEY_MAP[state] : RESOURCE_STATE_TEXT_KEY_MAP[state];

    return (
        <TooltippedTag tooltip={withTooltip && reason} variant={tagVariant} data-test-resource-state-tag={state}>
            <LocalizedText textKey={textKey} data-test-id="resourceStateTag" />
        </TooltippedTag>
    );
};
export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { resourceId }) => {
    const enterpriseId = getCurrentEnterpriseId();
    return {
        state: resourceId ? getResourceState(state, { id: resourceId, enterpriseId }) : undefined,
        reason: resourceId ? getResourceStateReason(state, { id: resourceId, enterpriseId }) : undefined,
    };
})(ResourceStateTag);
